export const StashTag = '#stash';
export const FlagTag = '#flag';
export const ArchiveTag = '#archive';

export const SystemTags = [StashTag, FlagTag, ArchiveTag];